import { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { firestore } from '../lib/firebase/config';
import { Verification } from '../types/verification';

export const useUserVerification = (userId: string) => {
  const [verification, setVerification] = useState<Verification | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserVerification = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      
      try {
        const verificationsRef = collection(firestore, 'verifications');
        const q = query(verificationsRef, where('userId', '==', userId));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          setVerification({
            id: doc.id,
            ...(doc.data() as Verification)
          });
        }
      } catch (err: any) {
        console.error('Error fetching user verification:', err);
        setError(err.message || 'Failed to fetch verification data');
      } finally {
        setLoading(false);
      }
    };

    fetchUserVerification();
  }, [userId]);

  return { verification, loading, error };
};